import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDoubleCheckmark1"><Path d="M18.3818 4.69922L17.8408 5.54102L8.84082 19.541L8.08887 20.7119L7.21875 19.625L2.21875 13.375L1.59473 12.5938L3.15625 11.3447L3.78125 12.125L7.91113 17.2881L16.1592 4.45898L16.6992 3.61816L18.3818 4.69922ZM22.3828 4.70605L21.8389 5.54492L12.5889 19.7949L12.0439 20.6328L10.3672 19.5439L10.9111 18.7051L20.1611 4.45508L20.7061 3.61719L22.3828 4.70605Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoubleCheckmark1;
